
import styles from './list.module.css';

export function List({ listItems }) {
  return (
    <ul className={styles.list}>
      {listItems?.map((listItem, id) => (
        <li key={id} className={styles.listItem}>
          {listItem}
        </li>
      ))}
    </ul>
  );
}
